import React from 'react';
import PropTypes from 'prop-types';
import { Elements, StripeProvider } from 'react-stripe-elements';
import i18n from '../../i18n';
import { getStripeApiKeyByLegalEntityName } from '../../utils/Payment';

const CustomStripeProvider = ({ children, legalEntity }) => {
    if (!legalEntity) {
        return;
    }

    const apiKey = getStripeApiKeyByLegalEntityName(legalEntity);

    return (
        <StripeProvider apiKey={apiKey}>
            <Elements
                locale={i18n.language}
                fonts={[
                    {
                        family: 'ft-regola-neue',
                        src: `url('https://assets.homeexchange.com/fonts/ft-regola-neue/regular/ft-regola-neue-regular.woff2') format('woff2'),
                            url('https://assets.homeexchange.com/fonts/ft-regola-neue/regular/ft-regola-neue-regular.woff') format('woff')`
                    }
                ]}
            >
                {children}
            </Elements>
        </StripeProvider>
    );
};

CustomStripeProvider.propTypes = {
    children: PropTypes.element.isRequired,
    legalEntity: PropTypes.string.isRequired
};

export default CustomStripeProvider;
